module.exports = __webpack_public_path__ + "img/favoritos.8c64061c.png";